import styled from '@emotion/styled'

export const _SummaryLineParagraph = styled('p')`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 0;
`
